import { Coordinate } from '_lib/api';
import { LatLngLiteral } from 'leaflet';
import { useMemo } from 'react';

import { toLatLng } from '../utils';

/**
 * react-leaflet calls `marker.setLatLng()` whenever the `position` prop changes identity, and
 * leaflet.markercluster answers the resulting `move` event by removing and re-adding the marker,
 * which closes an open spiderfy. Rebuild the position only when the coordinates really differ.
 */
export default (coordinates?: Coordinate): LatLngLiteral | null =>
  useMemo(
    () => (coordinates ? toLatLng(coordinates) : null),
    [coordinates?.[0], coordinates?.[1]],
  );
